import { IQuery } from '~/client/graph'
import { OperationRulesByProjectIdDocument } from '~/client/graph/operations/generated/OperationRules.generated'
import { PermitTypeListDocument } from '~/client/graph/operations/generated/PermitTypes.generated'
import InitialState from '~/client/src/shared/stores/InitialState'
import RootStore from '~/client/src/shared/stores/Root.store'

import * as e from './eventConstants'
import EventsStore from './Events.store'

// Quiet re-reads of the lists Ball-in-Court checks run against, dispatched by
// CommonContainer when the live connection may have missed changes. Unlike the
// LOAD_AND_LISTEN_* loaders they never empty a list or raise its loading flag,
// so an open workflow keeps rendering while the fresh copy arrives. They wait
// for the first load to finish and drop a reply for a project left meanwhile.
// Subscriptions keep running during the request, so each re-read carries a
// sync token: the store keeps whatever changed after the token was taken.
export default function (eventsStore: EventsStore, rootStore: RootStore) {
  eventsStore.on(e.REFRESH_OPERATION_RULES, (state: InitialState) => {
    const projectId = state.activeProject?.id
    if (
      !projectId ||
      state.loading.get(e.LOAD_AND_LISTEN_TO_OPERATION_RULES) !== false
    ) {
      return
    }

    const syncToken = rootStore.operationRulesStore.beginSync()

    return {
      graphQuery: {
        query: OperationRulesByProjectIdDocument,
        variables: { projectId },
        onSuccess: [e.OPERATION_RULES_REFRESHED, projectId, syncToken],
        onError: [e.NO_EFFECT],
      },
    }
  })

  eventsStore.on(
    e.OPERATION_RULES_REFRESHED,
    (
      state: InitialState,
      projectId: string,
      syncToken: number,
      { operationRules }: IQuery,
    ) => {
      if (projectId !== state.activeProject?.id || !operationRules?.data) {
        return
      }

      rootStore.operationRulesStore.syncList(operationRules.data, syncToken)
    },
  )

  eventsStore.on(e.REFRESH_WORKFLOW_TYPES, (state: InitialState) => {
    const projectId = state.activeProject?.id
    if (
      !projectId ||
      state.loading.get(e.LOAD_AND_LISTEN_TO_WORKFLOW_TYPES) !== false
    ) {
      return
    }

    const syncToken = rootStore.workflowTypesStore.beginSync()

    return {
      graphQuery: {
        query: PermitTypeListDocument,
        variables: { projectId },
        onSuccess: [e.WORKFLOW_TYPES_REFRESHED, projectId, syncToken],
        onError: [e.NO_EFFECT],
      },
    }
  })

  eventsStore.on(
    e.WORKFLOW_TYPES_REFRESHED,
    (
      state: InitialState,
      projectId: string,
      syncToken: number,
      { permitTypes }: IQuery,
    ) => {
      if (projectId !== state.activeProject?.id || !permitTypes?.data) {
        return
      }

      rootStore.workflowTypesStore.syncProjectSpecificTypes(
        permitTypes.data,
        syncToken,
      )
    },
  )
}
